import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class AdminOwnerResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name?: Nillable<string>;

  @jsonMember(String)
  public readonly email?: Nillable<string>;
}
